import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

/**
 * Fields type definition for content type 'TypeSmallCta'
 * @name TypeSmallCtaFields
 * @type {TypeSmallCtaFields}
 * @memberof TypeSmallCta
 */
export interface TypeSmallCtaFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'text' (Text)
     * @name Text
     * @localized true
     */
    text: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'url' (URL)
     * @name URL
     * @localized false
     */
    url: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'type' (Type)
     * @name Type
     * @localized false
     */
    type: EntryFieldTypes.Symbol<"Blue" | "Green" | "Link" | "link-color-button" | "primary-button" | "secondary-button">;
    /**
     * Field type definition for field 'size' (Size)
     * @name Size
     * @localized false
     */
    size: EntryFieldTypes.Symbol<"Small">;
    /**
     * Field type definition for field 'openInNewTab' (Open In New Tab)
     * @name Open In New Tab
     * @localized false
     */
    openInNewTab?: EntryFieldTypes.Boolean;
}

/**
 * Entry skeleton type definition for content type 'smallCta' (Small CTA)
 * @name TypeSmallCtaSkeleton
 * @type {TypeSmallCtaSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-26T01:57:15.632Z
 * @version 23
 */
export type TypeSmallCtaSkeleton = EntrySkeletonType<TypeSmallCtaFields, "smallCta">;
/**
 * Entry type definition for content type 'smallCta' (Small CTA)
 * @name TypeSmallCta
 * @type {TypeSmallCta}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-26T01:57:15.632Z
 * @version 23
 */
export type TypeSmallCta<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeSmallCtaSkeleton, Modifiers, Locales>;

export function isTypeSmallCta<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeSmallCta<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'smallCta'
}
